<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('invoiceClass.pageTitle') }}
      </h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <ts-button color="info" outline @click="goToCreate">
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end"></div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.inv_date }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.inv_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.card_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.first_name_en + ' ' + record.last_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.gender }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.class_name }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a
                href="#"
                @click.prevent="deleteRecord(record)"
                :disabled="record._deleting"
              >
                <i
                  class="fas fa-circle-notch spin ml-2"
                  v-if="record._deleting"
                ></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'invoiceClass',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('invoiceClass', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.invoiceClass.search
      },
      set(newValue) {
        this.$store.commit('invoiceClass/SET_SEARCH', newValue)
        this.$store.commit('invoiceClass/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('invoiceClass.invDate') },
        { name: this.$t('invoiceClass.invNumber') },
        { name: this.$t('invoiceClass.cardNumber') },
        { name: this.$t('invoiceClass.studentName') },
        { name: this.$t('invoiceClass.gender') },
        { name: this.$t('invoiceClass.class') },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  methods: {
    ...mapActions('invoiceClass', ['fetch', 'destroy']),
    goToCreate() {
      this.$router.push({ name: 'invoice-classes-create' })
    },
    fetchData(attributes = {}) {
      this.loading = true
      this.fetch(attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    deleteRecord(record) {
      record._deleting = true
      this.destroy({
        id: record.inv_id,
        data: {
          inv_id: record.inv_id,
          student_id: record.student_id,
          class_id: record.class_id
        }
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
